'use client'

import { sortBy, uniqBy } from 'lodash'
import type { LabelWithRole } from '@skop-app/lib-domain/types'

import { useUserContext } from '@/context'
import { useSelectedTeamMembers } from '@/hooks/useSelectedTeamMembers'

export function useSelectedTeammates(teamId?: string | null) {
  const { user, organizationScope } = useUserContext()
  const resolvedTeamId =
    teamId ?? organizationScope.selectedOrganizationId ?? ''
  const {
    data: members = [],
    isLoading,
    ...query
  } = useSelectedTeamMembers(teamId)

  const teammates: LabelWithRole[] = members.map((member) => ({
    label: member.name,
    value: member.userID,
    role: member.role,
    organizationID: member.organizationID ?? resolvedTeamId,
  }))

  if (user?.id && user?.name) {
    teammates.push({
      label: user.name,
      value: user.id,
      role: 'ADMIN',
      organizationID: user.id,
    })
  }

  return {
    ...query,
    data: sortBy(uniqBy(teammates, 'value'), 'label'),
    isLoading,
  }
}
